<script>
export default {
    name: 'DsMediaQuery',

    props: {
        /**
         * Named breakpoint to match on.
         */
        breakpoint: String,

        /**
         * Whether or not to exactly match the breakpoint.  This should be used in conjunction with the `breakpoint` prop.
         */
        exact: Boolean,

        /**
         * Minimum width of the breakpoint.
         */
        width: {
            type: Number,
            default: 0,
        },

        /**
         * Custom media query string.
         */
        query: String,
    },

    data() {
        return {
            mql: null,
            isMatch: false,
        };
    },

    created() {
        this.mql = window.matchMedia(this.mediaQuery);
        this.mql.addListener(this.onChange);
        this.isMatch = this.mql.matches;
    },

    beforeDestroy() {
        this.mql.removeListener(this.onChange);
    },

    computed: {
        mediaQuery() {
            const {
                width,
                breakpoint,
                query,
                exact,
            } = this;

            if (query) {
                return query;
            }

            if (breakpoint) {
                if (exact) {
                    switch (breakpoint) {
                    case 'extra-small':
                        return '(max-width: 749px)';
                    case 'small':
                        return '(min-width: 750px) and (max-width: 949px)';
                    case 'medium':
                        return '(min-width: 950px) and (max-width: 1199px)';
                    case 'large':
                        return '(min-width: 1200px) and (max-width: 1349px)';
                    case 'extra-large':
                        return '(min-width: 1350px)';
                    default:
                        return '';
                    }
                }

                switch (breakpoint) {
                case 'small':
                    return '(min-width: 750px)';
                case 'medium':
                    return '(min-width: 950px)';
                case 'large':
                    return '(min-width: 1200px)';
                case 'extra-large':
                    return '(min-width: 1350px)';
                default:
                    return '';
                }
            }

            return `(min-width: ${width}px)`;
        },
    },

    methods: {
        onChange(e) {
            this.isMatch = e.matches;
        },
    },

    render() {
        const { isMatch } = this;

        return this.$scopedSlots.default({
            isMatch,
        });
    },
};
</script>
